module.exports = __webpack_public_path__ + "img/powerpoint.eb5ee403.svg";